/**
 * 39 Apple-supported locales for retention messaging defaults.
 *
 * Mirror of config-manager/utils/retentionLocales.js. Backend re-validates submitted
 * locales against its own copy — keep both in sync if Apple adds a locale.
 */

export const SUPPORTED_LOCALES = [
  { code: 'ar-SA',   label: 'Arabic' },
  { code: 'ca',      label: 'Catalan' },
  { code: 'zh-Hans', label: 'Chinese (Simplified)' },
  { code: 'zh-Hant', label: 'Chinese (Traditional)' },
  { code: 'hr',      label: 'Croatian' },
  { code: 'cs',      label: 'Czech' },
  { code: 'da',      label: 'Danish' },
  { code: 'nl-NL',   label: 'Dutch' },
  { code: 'en-AU',   label: 'English (Australia)' },
  { code: 'en-CA',   label: 'English (Canada)' },
  { code: 'en-GB',   label: 'English (U.K.)' },
  { code: 'en-US',   label: 'English (U.S.)' },
  { code: 'fi',      label: 'Finnish' },
  { code: 'fr-FR',   label: 'French' },
  { code: 'fr-CA',   label: 'French (Canada)' },
  { code: 'de-DE',   label: 'German' },
  { code: 'el',      label: 'Greek' },
  { code: 'he',      label: 'Hebrew' },
  { code: 'hi',      label: 'Hindi' },
  { code: 'hu',      label: 'Hungarian' },
  { code: 'id',      label: 'Indonesian' },
  { code: 'it',      label: 'Italian' },
  { code: 'ja',      label: 'Japanese' },
  { code: 'ko',      label: 'Korean' },
  { code: 'ms',      label: 'Malay' },
  { code: 'no',      label: 'Norwegian' },
  { code: 'pl',      label: 'Polish' },
  { code: 'pt-BR',   label: 'Portuguese (Brazil)' },
  { code: 'pt-PT',   label: 'Portuguese (Portugal)' },
  { code: 'ro',      label: 'Romanian' },
  { code: 'ru',      label: 'Russian' },
  { code: 'sk',      label: 'Slovak' },
  { code: 'es-MX',   label: 'Spanish (Mexico)' },
  { code: 'es-ES',   label: 'Spanish (Spain)' },
  { code: 'sv',      label: 'Swedish' },
  { code: 'th',      label: 'Thai' },
  { code: 'tr',      label: 'Turkish' },
  { code: 'uk',      label: 'Ukrainian' },
  { code: 'vi',      label: 'Vietnamese' }
];

export const localeLabel = (l) => `${l.label} — ${l.code}`;

const LABEL_BY_CODE = SUPPORTED_LOCALES.reduce((acc, l) => {
  acc[l.code] = l.label;
  return acc;
}, {});

// Label for a locale code; falls back to the code itself.
export const localeLabelByCode = (code) => LABEL_BY_CODE[code] || code;
